import { render, staticRenderFns } from "./NewLinkedBankAccountForm.vue?vue&type=template&id=980a0eaa&scoped=true"
import script from "./NewLinkedBankAccountForm.vue?vue&type=script&lang=ts"
export * from "./NewLinkedBankAccountForm.vue?vue&type=script&lang=ts"
import style0 from "./NewLinkedBankAccountForm.vue?vue&type=style&index=0&id=980a0eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a0eaa",
  null
  
)

export default component.exports